import { useState } from 'react';
import { Button, Input, InputGroup } from 'reactstrap';
import { DailyScheduleAnnouncementDTO } from '../../../../interfaces/DailyScheduleInterface';

interface Props {
  announcements: DailyScheduleAnnouncementDTO[];
  onAdd: (text: string) => Promise<void>;
  onRemove: (id: string) => Promise<void>;
}

const AnnouncementsPanel = ({ announcements, onAdd, onRemove }: Props) => {
  const [text, setText] = useState('');
  const [adding, setAdding] = useState(false);

  const handleAdd = async () => {
    const trimmed = text.trim();
    if (!trimmed) return;
    setAdding(true);
    try {
      await onAdd(trimmed);
      setText('');
    } finally {
      setAdding(false);
    }
  };

  return (
    <div className="section-card mb-3 announcements-area">
      <div className="section-title">Announcements / Reminders</div>
      <div className="mb-2">
        {announcements.map((a) => (
          <span key={a.id} className="announcement-tag">
            {a.text}
            <button className="remove-btn" onClick={() => onRemove(a.id)} title="Remove">
              ×
            </button>
          </span>
        ))}
        {announcements.length === 0 && (
          <span className="text-muted" style={{ fontSize: '0.82rem' }}>
            No announcements yet.
          </span>
        )}
      </div>
      <InputGroup size="sm" style={{ maxWidth: 420 }}>
        <Input
          value={text}
          onChange={(e) => setText(e.target.value)}
          placeholder="Add reminder..."
          onKeyDown={(e) => e.key === 'Enter' && handleAdd()}
        />
        <Button color="primary" onClick={handleAdd} disabled={adding || !text.trim()}>
          + Add
        </Button>
      </InputGroup>
    </div>
  );
};

export default AnnouncementsPanel;
